import styled from 'styled-components';
import { Card, Typography } from '@equinor/eds-core-react';
import { spacings } from '../../../tokens/spacings';
import ParametersTable from '../../../components/ParametersTable';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacings.LARGE};
  padding: 0;
  background: transparent;
  max-width: 1600px;
  width: 100%;
  box-sizing: border-box;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const Description = styled.div`
  background: #f7f7f7;
  padding: 1rem;
  border-radius: 4px;
  margin-bottom: 1rem;
`;

export const DescriptionText = styled.p`
  margin: 0.5rem 0 0 0;
  color: #3d3d3d;
  line-height: 1.5;
`;

export const TemplateSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const TemplateName = styled.div`
  margin: 0.5rem 0;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const RadioGroup = styled.div`
  display: flex;
  gap: 2rem;
  margin-top: 0.5rem;
  flex-wrap: nowrap;
`;

export const StyledCard = styled(Card)`
  border: 1px solid #dcdcdc;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.08);
`;

export const RangeText = styled(Typography)`
  margin-left: 8px;
`;

export const SedimentSection = styled.div`
  margin-bottom: 2.5rem;
`;

export const SectionTitle = styled(Typography)`
  margin-bottom: 1.5rem;
  margin-top: 1.5rem;
`;

export const StyledParametersTable = styled(ParametersTable)`
  border: 1px solid #dcdcdc;
`;

export const TemplateNameText = styled(Typography)`
  margin-bottom: 1rem;
`;
